<template>
<!-- <li :class="'nav-item has-treeview '+menuOpen(item.meta.title)" v-if="!item.hidden"> -->
<li :class="'nav-item has-treeview menu-open'" v-if="!item.hidden">
    <!-- <a href="#" :class="'nav-link '+activeParent(item.meta.title)"> -->
    <a href="javascript:;" :class="'nav-link '">
        <i :class="'nav-icon fas '+item.meta.icon"></i>
        <p>
            {{item.meta.title}}
            <i class="fas fa-angle-left right"></i>
        </p>
    </a>
    <!-- <ul v-for="child in item.children" class="nav nav-treeview" :style="'display: '+display(item.meta.title)"> -->
    <ul v-for="child in item.children" class="nav nav-treeview">
        <li class="nav-item">
            <!-- <router-link :to="resolvePath(child.path)" :class="'nav-link '+active(child.meta.title)"> -->
            <router-link :to="resolvePath(child.path)" :class="'nav-link '">
                <i class="far fa-circle nav-icon"></i>
                <p>{{child.meta.title}}</p>
            </router-link>
        </li>
    </ul>
</li>
</template>
<script>
import path from 'path'
import { isExternal } from '@b/utils/validate'
import { mapGetters } from 'vuex'

export default {
    name: 'Item',
    props: {
        // route object
        item: {
            type: Object,
            required: true
        },
        isNest: {
            type: Boolean,
            default: false
        },
        basePath: {
            type: String,
            default: ''
        }
    },
    computed: {
        ...mapGetters([
           'page_name',
           'page_name_parent'
        ]),
    },
    methods: {
        resolvePath(routePath) {

            if (isExternal(routePath)) {
                return routePath
            }
            if (isExternal(this.basePath)) {
                return this.basePath
            }
            return path.resolve(this.basePath, routePath)
        },
        active(name){
            if(name === this.page_name){
                return 'active'
            }else{
                return ''
            }
        },
        activeParent(name){
            if(name === this.page_name_parent){
                return 'active'
            }else{
                return ''
            }
        },
        display(name){
            if(name === this.page_name_parent){
                return 'block;'
            }else{
                return 'none;'
            }
        },
        menuOpen(name){
            if(name === this.page_name_parent){
                return 'menu-open'
            }else{
                return ''
            }
        }
    }
  }
</script>